const zhCN = {
  addBtn: '添加设备',
  activeTimeBtn: '门禁有效时间',
  deleteBtn: '删除设备',

  deviceTypesTxt: '设备类型',
  deviceStatusTxt: '设备状态',
  deviceStatusAllOption: '全部',
  deviceSNOrNameTxt: '设备SN/设备名称',
  searchBtn: '搜索',

  listSN: '设备SN',
  listName: '设备名称',
  listType: '设备类型',
  listStatus: '设备状态',
  listVersion: '软件版本',
  listCloudPlatformExpiredAt: '云服务到期时间',
  listIotCardExpiredAt: '物联网到期时间',
  listPersonCount: '授权人员',
  listOperation: '操作',

  listConfigBtn: '配置',
  listMoreBtn: '更多',

  remoteOpenDoor: '远程开门',
  remoteCloseDoor: '远程关门',
  normallyOpen: '设备常开',
  reboot: '重启设备',

  sendingTips: 'return "发送 " + command + " 指令中..."',
  sendRemoteCommandSuccess: '远程指令发送成功！',
  sendRemoteCommandFail: '远程指令发送失败！',

  requestDeviceInfoFail: '获取设备信息失败！',

  deleteWarning: 'return "您确定要删除当前选中的 " + count + " 个设备？"',
  deleteWarningDesc: '删除设备后，设备所保存的所有人员信息、授权信息将被删除，设备将恢复到出厂设置！',
  batchDeleteSuccess: 'return "成功删除 " + count + " 个设备！"',
  bacthDeleteFail: 'return "删除失败 " + count + " 个设备！"',
  deleteFail: '删除失败！',

  addTips: 'return "添加设备 - " + org',

  deviceSN: '设备SN',
  deviceSNTxt: '请输入设备 SN 号',
  deviceSNBlank: '设备SN号不能为空！',

  deviceType: '设备类型',

  deviceName: '设备名称',
  deviceNameTxt: '请输入设备名称',
  deviceNameBlank: '设备名称不能为空！',
  deviceNameWarning: '设备名称最多20字！',

  addDeviceFail: '添加设备失败！',

  batchSetTimeWarnTitle: '选中项中包含访客一体机',
  batchSetTimeWarnDesc: '只有门禁一体机才能进行门禁有效时间设置！点击“继续”，将自动清除选中的访客一体机，并进入设置页。或者点击“取消”，取消访客一体机的选中，再进行操作。',

  continueBtn: '继续',
  confirmBtn: '确定',
  cancelBtn: '取消'
}
const enUS = {
  addBtn: 'Add',
  activeTimeBtn: 'Active Time Setting',
  deleteBtn: 'Delete',

  deviceTypesTxt: 'Device Type',
  deviceStatusTxt: 'Device Status',
  deviceStatusAllOption: 'All',
  deviceSNOrNameTxt: 'Device SN/Name',
  searchBtn: 'Search',

  listSN: 'SN',
  listName: 'Name',
  listType: 'Type',
  listStatus: 'Status',
  listVersion: 'Version',
  listPersonCount: 'Authorized',
  listOperation: 'Operation',

  listConfigBtn: 'Configuration',
  listMoreBtn: 'More',
  listCloudPlatformExpiredAt: 'CloudPlatformExpired',
  listIotCardExpiredAt: 'IotCardExpired',
  remoteOpenDoor: 'Remote Open Door',
  remoteCloseDoor: 'Remote Close Door',
  normallyOpen: 'Normally Open',
  reboot: 'Reboot',

  sendingTips: 'return command + " sending..."',
  sendRemoteCommandSuccess: 'Send remote command successfully!',
  sendRemoteCommandFail: 'Send remote command failed!',

  requestDeviceInfoFail: 'Request device information failed!',

  deleteWarning: 'return "Are you sure to delete the " + count + " devices?"',
  deleteWarningDesc: 'After deleting those devices, all personnel information and authorization information saved by those devices will be deleted, and those devices will be restored to factory Settings!',
  batchDeleteSuccess: 'return "Delete " + count + " devices successfully!"',
  bacthDeleteFail: 'return "Delete " + count + " devices failed!"',
  deleteFail: 'Delete failed!',

  addTips: 'return "Add Device - " + org',

  deviceSN: 'SN Number',
  deviceSNTxt: 'Enter device SN number',
  deviceSNBlank: 'Device SN number can\'t be blank!',

  deviceType: 'Device Type',

  deviceName: 'Device Name',
  deviceNameTxt: 'Enter device name',
  deviceNameBlank: 'Device name can\'t be blank!',
  deviceNameWarning: 'Device name is up to 20 words!',

  addDeviceFail: 'Add device failed!',

  batchSetTimeWarnTitle: 'The selected item contains the visitor all-in-one machine',
  batchSetTimeWarnDesc: 'Only the access control machine can set the effective time of access control! Clicking "Continue" will automatically clear the selected visitor all-in-one machine and enter the Settings page. Or click "Cancel" to cancel the selection of the visitor all-in-one machine, and then operate.',

  continueBtn: 'Continue',
  confirmBtn: 'Confirm',
  cancelBtn: 'Cancel'
}

export default { zhCN, enUS }
